import { ErrorHistogramChart } from './ErrorHistogramChart';
import type { ProductGroupHistogram } from '@/lib/types/ds/prediction-error-evaluation';

interface ProductGroupHistogramsProps {
  data: ProductGroupHistogram[];
}

export function ProductGroupHistograms({ data }: ProductGroupHistogramsProps) {
  if (!data || data.length === 0) {
    return <p className="text-sm text-muted-foreground">商品グループ別データがありません</p>;
  }

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      {data.map((group) => (
        <ErrorHistogramChart
          key={group.group_name}
          title={group.group_name}
          data={group}
          useLogScale
        />
      ))}
    </div>
  );
}
